import React from "react";

import {
	isPortrait,
	StandardBetSB
} from "@/modules/commonMobile";

/*
import {
	hasUnsubmittedTickets
} from "@/modules/commonMachineGame";
*/

import nary from "@/modules/nary";
import { IGameType } from "@/types/GlobalTypes";

interface IProps {
	game: IGameType;
	activateBetGroup: (e: any) => void;
}

export default class ShioBallsTabs extends React.Component<IProps> {
	render() {
		const game = this.props.game;
		const activeBetGroup = game.activeBetGroup;
		// const disableTabs = activeBetGroup && hasUnsubmittedTickets(game.unsubmittedTickets);

		const c3setTab = (
			StandardBetSB({
				classes: "sl-machine-tab" + (activeBetGroup === `c3set` ? " active" : ""),

				betLabel: "C3 Set",
				betNum: "",
				betGroup: `c3set`,

				commonProps: game,
				onClick: this.props.activateBetGroup,

				isTopRow: true,

				// disabled: disableTabs && activeBetGroup !== "c3set"
			})
		);

		return (
			<div className="tabs">
			{ isPortrait() ? null : c3setTab }
			
			{
				nary(3).map(item =>
					StandardBetSB({
						classes: "sl-machine-tab" + (activeBetGroup === `c${item}d1` ? " active" : ""),
						
						betLabel: "Colok " + item + "D",
						betNum: "",
						betGroup: `c${item}d1`,
						
						commonProps: game,
						onClick: this.props.activateBetGroup,
						
						isTopRow: true,

						// disabled: disableTabs && activeBetGroup !== `c${item}d1`
					})
				)
			}

				{isPortrait() ? c3setTab : null}
			
			{
				nary(3).map(item =>
					StandardBetSB({
						classes: "sl-machine-tab" + (activeBetGroup === `d${item}` ? " active" : ""),
						
						betLabel: item + "D",
						betNum: "",
						betGroup: `d${item}`,
						
						commonProps: game,
						onClick: this.props.activateBetGroup,
						
						isTopRow: true,

						// disabled: disableTabs && activeBetGroup !== `d${item}`
					})
				)
			}
			
			{
				StandardBetSB({
					classes: "sl-machine-tab" + (activeBetGroup === `3dset` ? " active" : ""),
					
					betLabel: "3D Set",
					betNum: "",
					betGroup: `3dset`,
					
					commonProps: game,
					onClick: this.props.activateBetGroup,
					
					isTopRow: true,

					// disabled: disableTabs && activeBetGroup !== "3dset"
				})
			}
			</div>
		);
	}
}